import React, { useEffect } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import JoinForm from 'components/Guest/PreJoin/JoinForm';
import { acquireWebcam } from 'actions/media';
import Logger from 'js-logger';
import { AudioType, getConstraints } from 'utils/deviceUtils';
import LocalVideoComponent from 'components/Guest/LocalVideo';

const PreJoin = () => {
  const dispatch = useDispatch();
  const classes = desktopStyles();
  const mediaSettings = useSelector((state: any) => state?.app?.mediaSettings);

  useEffect(() => {
    const acquire = async () => {
      try {
        // @ts-ignore
        dispatch(acquireWebcam(constraints));
      } catch (ex) {
        Logger.warn('Could not capture webcam', ex);
      }
    };
    const constraints = getConstraints({
      camera: '',
      localAudioMuted: false,
      localVideoMuted: false,
      microphone: '',
      speakers: '',
      audio: AudioType.computer, // always revert to 'computer' on init (some customers do not offer pstn)
      // guarantee a good value even if our resolutionMap changes
      resolution: 'default'
    });
    Logger.info('attempting to capture stream', constraints);
    acquire();
  }, [dispatch, mediaSettings]);

  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <Box className={classes.detailWrapper}>
          <JoinForm enableReinitialize />
        </Box>
        <Box className={classes.settingsPreview} data-testid="previewDivision">
          <LocalVideoComponent guestFlow />
          {/* <MicAndVideoPreview />*/}
        </Box>
      </Box>
    </Box>
  );
};

const desktopStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    maxWidth: '100%',
    overflow: 'hidden',
    padding: 0
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    '@media (orientation: portrait)': {
      flexDirection: 'column-reverse'
    }
  },
  detailWrapper: {
    display: 'flex',
    flex: '0 0 auto',
    flexDirection: 'column',
    overflow: 'auto',
    justifyContent: 'center',
    '@media (orientation: landscape)': {
      maxWidth: '50%'
    },
    '@media (orientation: portrait)': {
      width: '100%'
    }
  },
  settingsPreview: {
    backgroundColor: '#000000',
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    height: 'calc(100vh - 51px)', // subtract the height of the header from the vh
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    '@media (orientation: portrait)': {
      maxWidth: '100%'
    }
  }
}));

export default PreJoin;
